// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Images/pattern-background-lines.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.contents-top-wrap {
    min-height: calc(100vh - 62px);
    display: flex;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.wrapper{
    font-family: 'IBM-Plex-sans';
    max-width: 600px;
    min-width: 35%;
    background-color: white;
    border-radius: 8px;
    border: none;
    margin: auto;
    height: 535px;
    padding: 16px 20px;
    border: solid 1px #ededed;
}

input[type="file"] {
    display: none;
}
.file-label {
    border: 1px solid #477afe;
    background-color: #f5f8ff;
    color: #477afe;
    width: -webkit-fill-available;
    margin: 0 30px;
    display: inline-block;
    cursor: pointer;
    border-radius: 8px;
    height: 96px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.corrupt-file {
    border: 1px solid #fe4747;
    background-color: #ffebeb;
}

.upload-block-wrap {
    display: inline-block;
    padding: 12px 14px;
}
.upload-block-wrap p {
    margin: 8px 0;
}

.upload-img{
    height: 50px;
    display: inline;
    margin-right: 20px;
}

#reportFileName{
    max-width: 400px;
    overflow: hidden;
}

#logFileName{
    max-width: 400px;
    overflow: hidden;
}

.selectList select{
    margin-top: 5px;
    padding: 13px;
    margin: 0 30px;
    width: -webkit-fill-available;
    min-width: 250px;
    color: #477afe;
    border-radius: 8px;
    margin-bottom: 16px;
}

.selectList select option{
    padding: 8px;
}

.selectList {
   width: 100%;
}

.errMsg{
    color: red;
    text-align: right;
    font-family: 'IBM-Plex-sans-semibold';
    margin-right: 30px;
    margin-top: 10px;
}

.sec-heading {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;
}

.sample-file-section {
    cursor: pointer;
    font-family: 'IBM-Plex-sans-semibold';
}

.sample-file-section a {
    color: #477afe;
    text-decoration: none;
}

.sample-file-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}

.first-sec-first-part {
    display: flex;
}

.first-sec {
    margin-right: 30px;
    justify-content: space-between;
}

.head-number {
    width: 22px;
    padding-top: 1px;
    height: 20px;
    margin-right: 6px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    border-radius: 50%;
    background-color: #477afe;
    color: #fff;
}

.sec-head-name {
    font-family: 'IBM-Plex-sans-bold';
    font-size: 14px;
}

.second-sec {
    margin-top: 26px;
}

.sec-disabled {
    opacity: 0.7;
    cursor: not-allowed;
    pointer-events: none;
}

.generate-btn-wrap {
    margin: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.generate-btn {
    background-color: #477afe;
    color: #fff;
    padding: 10px 30px;
    border-radius: 8px;
    border: none;
    width: 170px;
    font-size: 14px;
    font-family: 'IBM-Plex-sans';
    cursor: pointer;
    position: relative;
    bottom: -20px;
}

.generate-btn:disabled {
    pointer-events: none;
    opacity: 0.6;
}

.spinnerWrap {
    position: absolute;
    width: 95vw;
    height: 90vh;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginSuccess.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,aAAa;IACb,yDAAiE;AACrE;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;GACG,WAAW;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":["\n.contents-top-wrap {\n    min-height: calc(100vh - 62px);\n    display: flex;\n    background-image: url(\"/src/Images/pattern-background-lines.svg\");\n}\n\n.wrapper{\n    font-family: 'IBM-Plex-sans';\n    max-width: 600px;\n    min-width: 35%;\n    background-color: white;\n    border-radius: 8px;\n    border: none;\n    margin: auto;\n    height: 535px;\n    padding: 16px 20px;\n    border: solid 1px #ededed;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n.file-label {\n    border: 1px solid #477afe;\n    background-color: #f5f8ff;\n    color: #477afe;\n    width: -webkit-fill-available;\n    margin: 0 30px;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 8px;\n    height: 96px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.corrupt-file {\n    border: 1px solid #fe4747;\n    background-color: #ffebeb;\n}\n\n.upload-block-wrap {\n    display: inline-block;\n    padding: 12px 14px;\n}\n.upload-block-wrap p {\n    margin: 8px 0;\n}\n\n.upload-img{\n    height: 50px;\n    display: inline;\n    margin-right: 20px;\n}\n\n#reportFileName{\n    max-width: 400px;\n    overflow: hidden;\n}\n\n#logFileName{\n    max-width: 400px;\n    overflow: hidden;\n}\n\n.selectList select{\n    margin-top: 5px;\n    padding: 13px;\n    margin: 0 30px;\n    width: -webkit-fill-available;\n    min-width: 250px;\n    color: #477afe;\n    border-radius: 8px;\n    margin-bottom: 16px;\n}\n\n.selectList select option{\n    padding: 8px;\n}\n\n.selectList {\n   width: 100%;\n}\n\n.errMsg{\n    color: red;\n    text-align: right;\n    font-family: 'IBM-Plex-sans-semibold';\n    margin-right: 30px;\n    margin-top: 10px;\n}\n\n.sec-heading {\n    display: flex;\n    margin-bottom: 8px;\n    font-size: 14px;\n}\n\n.sample-file-section {\n    cursor: pointer;\n    font-family: 'IBM-Plex-sans-semibold';\n}\n\n.sample-file-section a {\n    color: #477afe;\n    text-decoration: none;\n}\n\n.sample-file-icon {\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n}\n\n.first-sec-first-part {\n    display: flex;\n}\n\n.first-sec {\n    margin-right: 30px;\n    justify-content: space-between;\n}\n\n.head-number {\n    width: 22px;\n    padding-top: 1px;\n    height: 20px;\n    margin-right: 6px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: bold;\n    border-radius: 50%;\n    background-color: #477afe;\n    color: #fff;\n}\n\n.sec-head-name {\n    font-family: 'IBM-Plex-sans-bold';\n    font-size: 14px;\n}\n\n.second-sec {\n    margin-top: 26px;\n}\n\n.sec-disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.generate-btn-wrap {\n    margin: 15px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.generate-btn {\n    background-color: #477afe;\n    color: #fff;\n    padding: 10px 30px;\n    border-radius: 8px;\n    border: none;\n    width: 170px;\n    font-size: 14px;\n    font-family: 'IBM-Plex-sans';\n    cursor: pointer;\n    position: relative;\n    bottom: -20px;\n}\n\n.generate-btn:disabled {\n    pointer-events: none;\n    opacity: 0.6;\n}\n\n.spinnerWrap {\n    position: absolute;\n    width: 95vw;\n    height: 90vh;\n    pointer-events: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 200;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
